import { AnalyticsEvent } from '®shared/events/analytics-event';
import { LaunchMethod } from '®shared/events/launch-method.constant';
import { LaunchMode } from '®shared/events/launch-mode.constant';

type TargetType = 'lists' | 'sections' | 'items';

export interface ListEntryPointEventProps {
  launch_method: string;
  list_id: string;
  mode: string;
  target_id: string;
  target_type: TargetType;
}

export interface ListEntryPointAnalyticsEvent extends AnalyticsEvent {
  className: 'list.entry_point';
  props: ListEntryPointEventProps;
}

export function createListEntryPointEvent(
  listId: string,
  target: { type: TargetType; id: string },
  launchMethod: LaunchMethod,
  mode: LaunchMode,
): ListEntryPointAnalyticsEvent {
  return {
    className: 'list.entry_point',
    props: {
      launch_method: launchMethod,
      list_id: listId,
      mode,
      target_id: target.id,
      target_type: target.type,
    },
  };
}
